// extracted by mini-css-extract-plugin
module.exports = {"container":"ColourPicker_container__1etzr","button":"ColourPicker_button__1G7-U"};